
import { io } from "socket.io-client";
import store from "./redux/store";
import { setOnlineUsers } from "./redux/onlineUsers/onlineUsersActions";

let socket;
let connectedUsers = { clinicId: null, clinicUsers: [] }; // Store connected users locally

const BASE_URL = process.env.REACT_APP_SOCKET_URL;

export function connectSocket() {
 
  if (socket && socket.connected) return socket;
  
  socket = io(BASE_URL, {
    path: "/socket/v2",       
    withCredentials: true,
    transports: ["websocket"],
    reconnection: true,
    reconnectionAttempts: 5,
    reconnectionDelay: 1000,
    reconnectionDelayMax: 5000,
    timeout: 60000,
  });

  socket.on("connect", () => {
    // No need for anything here now
  });

  socket.on("connect_error", (err) => {
    // No need for anything here now
  });

  socket.on("disconnect", (reason) => {
    // No need for anything here now
  });

  // Listen for connected users (grouped by clinic)
  socket.on("connectedUsers", (data) => {
    
    const dispatch = store.dispatch;
    connectedUsers = data; // Update local state
    dispatch(setOnlineUsers(data.clinicUsers || []));
   
  });

  return socket;
}

export function disconnectSocket() {
  if (socket) {
    socket.disconnect();
    socket = null;
  }
}

export function getConnectedUsers() {
  return connectedUsers;
}

export default socket;